"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerSelectComponent = void 0;
/* eslint-disable max-len */
const core_1 = require("@angular/core");
const enums_1 = require("../@shared-types/customer/enums");
const dom_1 = require("../shared/services/dom");
const overlay_component_1 = __importDefault(require("./overlay.component"));
const customer_1 = require("../shared/models/customer/customer");
let CustomerSelectComponent = class CustomerSelectComponent {
    constructor(domService, customer) {
        this.domService = domService;
        this.customer = customer;
        this.customerIdChange = new core_1.EventEmitter();
        this.customerChange = new core_1.EventEmitter();
        this.showOverlay = false;
        this.selectedCustomerDescription = '';
        this.selectedCustomer = null;
        this.openOverlay = () => {
            this.showOverlay = true;
            const overlayComponent = this.domService
                .appendComponentToBody(overlay_component_1.default);
            overlayComponent.customerIdChange.subscribe((customerId) => {
                this.customerIdChange.emit(customerId);
            });
            overlayComponent.customerChange.subscribe((customer) => {
                this.selectedCustomer = customer;
                this.closeOverlay();
                this.customerChange.emit(customer);
            });
            overlayComponent.exit.subscribe(() => this.closeOverlay());
        };
        this.updateSelectionDescription = () => {
            if (this.selectedCustomer) {
                if (this.selectedCustomer.type === enums_1.ECustomerType.PRIVATE && this.selectedCustomer.firstName && this.selectedCustomer.lastName) {
                    this.selectedCustomerDescription = `${this.selectedCustomer.firstName} ${this.selectedCustomer.lastName}`;
                }
                else if (this.selectedCustomer.type === enums_1.ECustomerType.COMMERCIAL && this.selectedCustomer.companyName) {
                    this.selectedCustomerDescription = `${this.selectedCustomer.companyName}`;
                }
                else {
                    this.selectedCustomerDescription = 'Kunde ausgewählt';
                }
            }
            else {
                this.selectedCustomerDescription = '';
            }
        };
        this.closeOverlay = () => {
            this.updateSelectionDescription();
            this.showOverlay = false;
            this.domService.destroy();
        };
        this.deleteSelection = () => {
            this.selectedCustomer = null;
            this.updateSelectionDescription();
            this.customerIdChange.emit(null);
            this.customerChange.emit(null);
        };
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.customerId)
                return;
            this.selectedCustomer = yield this.customer.get(this.customerId);
            this.updateSelectionDescription();
            this.customerChange.emit(this.selectedCustomer);
        });
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CustomerSelectComponent.prototype, "customerId", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CustomerSelectComponent.prototype, "placeholder", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], CustomerSelectComponent.prototype, "customerIdChange", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], CustomerSelectComponent.prototype, "customerChange", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], CustomerSelectComponent.prototype, "required", void 0);
CustomerSelectComponent = __decorate([
    (0, core_1.Component)({
        selector: 'customer-select',
        templateUrl: require('./customer-select.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof dom_1.DomService !== "undefined" && dom_1.DomService) === "function" ? _a : Object, typeof (_b = typeof customer_1.CustomerModel !== "undefined" && customer_1.CustomerModel) === "function" ? _b : Object])
], CustomerSelectComponent);
exports.CustomerSelectComponent = CustomerSelectComponent;
